import _ from "lodash";

export const getLoginLoading = (auth) =>
  _.get(auth, ["login", "loading"], false);
export const getLoginData = (auth) => _.get(auth, ["login", "items"], null);
export const getLoginStatus = (auth) => _.get(auth, ["login", "status"], false);
export const getLoginDataData = (item) => _.get(item, ["Data"], null);
export const getLoginDataIsMasterAcc = (item) =>
  _.get(item, ["is_master_account"], null);
export const getLoginDataIsMaybankAutho = (item) =>
  _.get(item, ["is_maybank_authorize"], null);
export const getLoginDataNeedSetUserID = (item) =>
  _.get(item, ["need_set_user_id"], null);
export const getLoginDataRedirectUrl = (item) =>
  _.get(item, ["redirect_url"], null);
export const getLoginDataSessionExpiryEnd = (item) =>
  _.get(item, ["session_expiry_end"], null);
export const getLoginDataSessionExpiryWarning = (item) =>
  _.get(item, ["session_expiry_warning"], null);
export const getLoginDataToken = (item) => _.get(item, ["token"], null);
export const getLoginDataDirectClient = (item) =>
  _.get(item, ["direct_client"], null);
export const getMessage = (item) => _.get(item, ["Message"], null);
export const getLoginSuccess = (item) => _.get(item, ["Success"], null);
export const getConfirmLoginLoading = (auth) =>
  _.get(auth, ["confirmLogin", "loading"], false);
export const getConfirmLoginData = (auth) =>
  _.get(auth, ["confirmLogin", "items"], null);
export const getConfirmLoginStatus = (auth) =>
  _.get(auth, ["confirmLogin", "status"], false);
// export const getAuthToken = (auth) => _.get(auth, ["authToken"], null);

//login data
export const getLoginRequestKey = (item) =>
  _.get(item, ["LoginRequestKey"], null);
export const getTwoFAReferenceCode = (item) =>
  _.get(item, ["TwoFAReferenceCode"], null);

//confirmLoginData
export const getPasscodeID = (item) => _.get(item, ["PasscodeId"], null);
export const getPasscode = (item) => _.get(item, ["Passcode"], null);
export const getAccountType = (item) => _.get(item, ["AccountType"], null);
export const getSessionID = (item) => _.get(item, ["session_id"], null);
export const getNeedChangeUserId = (item) =>
  _.get(item, ["NeedChangeUserId"], null);
export const getSessionExpiryWarning = (item) =>
  _.get(item, ["SessionExpiryWarning"], null);
export const getSessionExpiryEnd = (item) =>
  _.get(item, ["SessionExpiryEnd"], null);
export const getNeedSetUserId = (item) => _.get(item, ["NeedSetUserId"], null);
export const getIsMasterAccount = (item) =>
  _.get(item, ["IsMasterAccount"], null);
export const getNric = (item) => _.get(item, ["Nric"], null);

//Forgot User ID
export const getForgotUserIdLoading = (auth) =>
  _.get(auth, ["forgotUserId", "loading"], false);
export const getForgotUserIdData = (auth) =>
  _.get(auth, ["forgotUserId", "items"], null);
export const getForgotUserIdStatus = (auth) =>
  _.get(auth, ["forgotUserId", "status"], false);
export const getForgotUserIdResponseStatus = (item) =>
  _.get(item, ["IsSuccess"], null);
export const getForgotUserIdOtpReference = (item) =>
  _.get(item, ["OtpReference"], null);
export const getForgotUserIdStatusCode = (item) =>
  _.get(item, ["StatusCode"], null);
export const getForgotUserIdMobilePhoneLabel = (item) =>
  _.get(item, ["MobilePhoneLabel"], null);
export const getForgotUserIdDataMessage = (item) =>
  _.get(item, ["Message"], null);

//Get Current User ID
export const getCurrentUserIdLoading = (auth) =>
  _.get(auth, ["getUserId", "loading"], false);
export const getCurrentUserIdData = (auth) =>
  _.get(auth, ["getUserId", "items"], null);
export const getCurrentUserIdStatus = (auth) =>
  _.get(auth, ["getUserId", "status"], false);
export const getCurrentUserId = (item) => _.get(item, ["UserId"], null);

//Resend Otp
export const resendOtpLoading = (auth) =>
  _.get(auth, ["resendOtp", "loading"], false);
export const resendOtpData = (auth) =>
  _.get(auth, ["resendOtp", "items"], null);
export const resendOtpStatus = (auth) =>
  _.get(auth, ["resendOtp", "status"], false);
export const getResendOtpReference = (item) =>
  _.get(item, ["OtpReference"], null);

//Forgot Password Request
export const forgotPasswordReqLoading = (auth) =>
  _.get(auth, ["forgotPassReq", "loading"], false);
export const forgotPasswordReqData = (auth) =>
  _.get(auth, ["forgotPassReq", "items"], null);
export const forgotPasswordReqStatus = (auth) =>
  _.get(auth, ["forgotPassReq", "status"], false);
export const forgotPasswordReqResponseStatus = (item) =>
  _.get(item, ["Success"], null);
export const getForgotPasswordStatusCode = (item) =>
  _.get(item, ["StatusCode"], null);
export const forgotPasswordReqMobilePhoneLabel = (item) =>
  _.get(item, ["MobilePhoneLabel"], null);
export const forgotPasswordReqDataMessage = (item) =>
  _.get(item, ["Message"], null);

//Verify Forgot Pass Otp
export const verifyForgotPassOtpLoading = (auth) =>
  _.get(auth, ["forgotPassOtp", "loading"], false);
export const verifyForgotPassOtpData = (auth) =>
  _.get(auth, ["forgotPassOtp", "items"], null);
export const verifyForgotPassOtpStatus = (auth) =>
  _.get(auth, ["forgotPassOtp", "status"], false);
export const verifyForgotPassOtpReference = (item) =>
  _.get(item, ["OTPReference"], null);

//Change password Request
export const changePasswordLoading = (auth) =>
  _.get(auth, ["changePassword", "loading"], false);
export const changePasswordData = (auth) =>
  _.get(auth, ["changePassword", "items"], null);
export const changePasswordStatus = (auth) =>
  _.get(auth, ["changePassword", "status"], false);
export const changePasswordDataMessage = (item) =>
  _.get(item, ["Message"], null);
export const changePasswordDataData = (item) => _.get(item, ["Data"], null);

//Login Portal Request
export const loginPortalLoading = (auth) =>
  _.get(auth, ["loginPortal", "loading"], false);
export const loginPortalData = (auth) =>
  _.get(auth, ["loginPortal", "items"], null);
export const loginPortalStatus = (auth) =>
  _.get(auth, ["loginPortal", "status"], false);
export const loginPortalEnableMaintenance = (item) =>
  _.get(item, ["EnableMaintenance"], null);
export const loginPortalMaintenanceMsg = (item) =>
  _.get(item, ["MaintenanceMessage"], null);
export const loginPortalReturnUrl = (item) => _.get(item, ["returnUrl"], null);
export const loginPortalSingpassClientId = (item) =>
  _.get(item, ["singpassClientID"], null);
export const loginPortalSingpassRedirectUrl = (item) =>
  _.get(item, ["singpassRedirectUrl"], null);
export const loginPortalSingPassUAT = (item) =>
  _.get(item, ["singpassUAT"], null);
export const getIsMaybankAuthorizeBool = (item) =>
  _.get(item, ["IsMaybankAuthorize"], null);

//Get Authorization Auth
export const getAuthorizationAuthLoading = (auth) =>
  _.get(auth, ["getAuthorizationAuth", "loading"], false);
export const getAuthorizationAuthData = (auth) =>
  _.get(auth, ["getAuthorizationAuth", "items"], null);
export const getAuthorizationAuthStatus = (auth) =>
  _.get(auth, ["getAuthorizationAuth", "status"], false);
export const getAuthorizationAuthDataMsg = (item) =>
  _.get(item, ["message"], null);
export const getAuthorizationAuthDataRedirectUrl = (item) =>
  _.get(item, ["redirectUrl"], null);

//Auth Token
export const getAuthTokenLoading = (auth) =>
  _.get(auth, ["authToken", "loading"], false);
export const getAuthTokenData = (auth) =>
  _.get(auth, ["authToken", "items"], null);
export const getAuthTokenStatus = (auth) =>
  _.get(auth, ["authToken", "status"], false);

//Auth Token
export const getSingPassLoading = (auth) =>
  _.get(auth, ["getSingPass", "loading"], false);
export const getSingPassData = (auth) =>
  _.get(auth, ["getSingPass", "items"], null);
export const getSingPassStatus = (auth) =>
  _.get(auth, ["getSingPass", "status"], false);
export const getSingPassDataErrorMsg = (item) =>
  _.get(item, ["error_message"], null);
export const getSingPassDataToken = (item) => _.get(item, ["token"], null);
export const getSingPassDataNeedSetUserID = (item) =>
  _.get(item, ["need_set_user_id"], null);
export const getSingPassDataIsMasterAccount = (item) =>
  _.get(item, ["is_master_account"], null);
export const getSingPassDataSessionExpiryWarning = (item) =>
  _.get(item, ["session_expiry_warning"], null);
export const getSingPassDataSessionExpiryEnd = (item) =>
  _.get(item, ["session_expiry_end"], null);
export const getSingPassDataSessionId = (item) =>
  _.get(item, ["session_id"], null);
export const getSingPassDataDirectClient = (item) =>
  _.get(item, ["direct_client"], null);

  //Maintenance Msg
export const getMaintenanceMsgLoading = (auth) =>
_.get(auth, ["getMaintenanceMsg", "loading"], false);
export const getMaintenanceMsgData = (auth) =>
_.get(auth, ["getMaintenanceMsg", "items"], null);
export const getMaintenanceMsgStatus = (auth) =>
_.get(auth, ["getMaintenanceMsg", "status"], false);

export const generateLoginOtpLoading = (auth) =>
_.get(auth, ["generateLoginOTP", "loading"], false);
export const generateLoginOtpData = (auth) =>
_.get(auth, ["generateLoginOTP", "items"], null);
export const generateLoginOtpStatus = (auth) =>
_.get(auth, ["generateLoginOTP", "status"], false);

